import DisplayPopoutTwo from 'components/project/analysis/results/dashboards/widgets/DisplayPopoutTwo.vue';
import { BfButton } from 'src/components/Butterfly';
import Vue from 'vue';
export default Vue.extend({
    components: { DisplayPopoutTwo, BfButton },
    props: {
        /** list of menus to show.  */
        menus: { type: Array, required: true, default: () => [] },
        /** vertical menu instead of horizontal default */
        vertical: { type: Boolean, default: false },
        bound: { type: HTMLElement, default: null, required: false },
        maxLabelLength: { type: Number, required: false, default: 25 }
    },
    data() {
        return {
            visiblePopover: null
        };
    },
    methods: {
        togglePopover(menu, e) {
            this.visiblePopover = this.visiblePopover === menu ? null : menu;
            // If in vertical mode, we need to position the menu in its fixed
            // position so that it works with the overflow-y: scroll wrapper
            if (this.visiblePopover && this.vertical) {
                this.$nextTick(() => {
                    const wrapperEl = e.target.closest('.menu');
                    const headerEl = wrapperEl.querySelector('.header');
                    const menuEl = wrapperEl.querySelector('.dropdown-menu');
                    const wrapperRect = headerEl.getBoundingClientRect();
                    menuEl.style.marginTop = '0px';
                    menuEl.style.right = `${window.innerWidth - wrapperRect.right}px`;
                    // Make sure the menu is not off the screen
                    let top = wrapperRect.bottom;
                    if (top + menuEl.clientHeight > window.innerHeight) {
                        top = window.innerHeight - menuEl.clientHeight - 20;
                    }
                    menuEl.style.top = `${top}px`;
                });
            }
        },
        setSelection(menu, item) {
            /** inform parent of item selected & what menu it was
             * @event onSelect
             * @property {string} menu identifies the menu by name
             * @property {array} item identifies the selection [ title, selection]
            */
            this.$emit('onSelect', menu, item);
        },
        findSelectionLabel(selection, options) {
            if (options === undefined)
                return selection;
            const flatOptions = options.flat().reduce((acc, menu) => {
                // This protects us from the case where a menu might have the same
                // value in different columns. If we check that this column has
                // a value selected, we know that it is the right one
                if (menu.selected !== null) {
                    acc.push(...menu.options);
                }
                return acc;
            }, []);
            const option = flatOptions?.find(el => el.value === selection);
            return option && option.label || selection;
        },
        hidePopover() {
            this.visiblePopover = null;
        }
    }
});
